var interval = null;
import NoTrace from '@/utils/noTrace';

function isEmpty(obj) {
    if (typeof obj == "undefined" || obj == null || obj == "") {
        return true;
    } else {
        return false;
    }
}

import {
    identification
} from "@http/user_center/userInfo";
import {
    sendMsg,
    getIdCardUploadUrl,
    businessUploadInfo,
    entRemittanceSupply
} from "@http/user_center/realName";

let Methods = {

    // 用户信息
    async identification() {
        let res = await identification({hidden: false});
        if (res.enterprise) {
            this.form = Object.assign({},res.enterprise)
            this.form.name1 = res.enterprise.name
            this.form.name2 = res.enterprise.uscc
            this.form.name3 = res.enterprise.name
            // this.usccUrl = this.form.businessUrl
            this.form.businessUrl = ''
        }
        if (JSON.parse(sessionStorage.getItem('enterPriseForm'))) {
            let sessionInfo = JSON.parse(sessionStorage.getItem('enterPriseForm'));
            this.form = Object.assign({},this.form, sessionInfo)
            this.usccUrl = this.form.viewUrl
            this.idcard_front_viewUrl = this.form.idcard_front_viewUrl
            this.idcard_tails_viewUrl = this.form.idcard_tails_viewUrl
        }
        // this.form.contactsVerifyCode = ''
    },

    // 验证码
    async getVerificationCode() {
        var that = this;
        if (!that.form.contactsPhone) {
            that.$msg("联系人手机号不能为空");
            return false;
        }
        let reg = /^1[23456789]\d{9}$/;
        if (!reg.test(that.form.contactsPhone)) {
            that.$msg("手机号格式不正确");
            return false;
        }
        this.getCode();
        that.disabled = true;
        // 开始获取无痕验证码
        NoTrace.start((nvc) => {
            that.nvc = nvc
        }, that.executeFun, {
            phone: that.form.contactsPhone,
            nvc: '',
            afsVersion: 2
        })
    },

    executeFun (params) {
        let that=this;
        return new Promise(async (resolve, reject) => {
            try {
                let res = await sendMsg(params);
                resolve(res)
                that.$msg(res.message, "success");
            }catch (err) {
                reject(err)
                that.$msg('发送失败')
                clearInterval(interval);
                that.yzmtext = "获取验证码";
                that.disabled = false;
            }
        })
    },

    // 验证码倒计时
    getCode() {
        var that = this;
        var currentTime = that.currentTime;
        interval = setInterval(function () {
            currentTime--;
            that.yzmtext = "(" + currentTime + "s)重新获取";
            if (currentTime <= 0) {
                clearInterval(interval);
                that.yzmtext = "重新获取";
                that.currentTime = 60;
                that.disabled = false;
            }
        }, 1000);
    },

    // 营业执照
    chooseFile() {
        let that = this;
        that.percentage = 0;
        let inputDOM = this.$refs.inputer;
        this.fil = inputDOM.files;
        let size = Math.floor(this.fil[0].size);
        let name = inputDOM.files[0].name;
        let index = name.lastIndexOf(".");
        let Format = name.substring(index);
        let arry_format = [".jpg", ".jpeg", ".png", ".bmp"];
        if (arry_format.indexOf(Format) === -1) {
            this.$msg("文件格式不符合要求");
            this.fil = {};
            this.$refs.inputer.value = null;

            return false;
        }
        console.log(size);
        if (size === 0) {
            this.$msg("图片大小为0kb，请更换图片");
            this.fil = {};
            this.$refs.inputer.value = null;
            return false;
        }

        if (size > 10 * 1024 * 1000) {
            this.$msg("文件大小不能大于10M");
            this.fil = {};
            this.$refs.inputer.value = null;

            return false;
        }
        that.progress = true;
        businessUploadInfo()
            .then((res) => {
                this.$request({
                    method: "PUT",
                    url: res.uploadUrl,
                    data: that.fil[0].slice(0, that.fil[0].size),
                    timeout: 86400000,
                    headers: {
                        "content-type": "application/octet-stream",
                    },
                    onUploadProgress: function (progressEvent) {
                        that.percentage =
                            Math.floor(
                                (progressEvent.loaded /
                                    progressEvent.total) *
                                100
                            ) | 0;
                    },
                })
                    .then(async () => {
                        that.usccUrl = res.viewUrl;
                        that.form.businessUrl = res.businessUrl;
                        that.form.viewUrl = res.viewUrl;
                        setTimeout(()=>{
                            that.progress = false;
                        },700)

                    })
                    .catch((err) => {
                        that.progress = false;
                        console.log(err);
                    });
            })
    },

    //身份证正反面
    chooseIdCard(n) {
        let that = this;
        that.percentage = 0;
        let inputDOM;
        if (n == 0) {
            inputDOM = this.$refs.idcard_front;
        } else {
            inputDOM = this.$refs.idcard_tails;
        }
        let size = Math.floor(inputDOM.files[0].size);
        let name = inputDOM.files[0].name;
        let index = name.lastIndexOf('.');
        let Format = name.substring(index);
        let arry_format = ['.jpg', '.jpeg', '.png'];
        if (arry_format.indexOf(Format) === -1) {
            this.$msg("文件格式不符合要求");
            n == 0 ? this.$refs.idcard_front.value = null : this.$refs.idcard_tails.value = null;

            return false;
        }
        if (size === 0) {
            this.$msg("图片大小为0kb，请更换图片");
            this.fil = {};
            this.$refs.inputer.value = null;
            return false;
        }
        if (size > 10 * 1024 * 1000) {
            this.$msg("文件大小不能大于10M");
            n == 0 ? this.$refs.idcard_front.value = null : this.$refs.idcard_tails.value = null;

            return false;
        }
        that.progress = true;

        getIdCardUploadUrl().then((res) => {
            that.percentage = 0;
            that.currentRate = 0;
            this.$request({
                method: "PUT",
                url: res.uploadUrl,
                data: inputDOM.files[0].slice(0, inputDOM.files[0].size),
                timeout: 86400000,
                headers: {
                    'content-type': 'application/octet-stream'
                },
                onUploadProgress: function (progressEvent) {
                    that.progress = true;
                    that.percentage = ((progressEvent.loaded / progressEvent.total) * 100) | 0
                }
            }).then(async () => {
                n == 0 ? (that.idcard_front_viewUrl = res.viewUrl, that.form.idcard_front_viewUrl = res.viewUrl) :
                    (that.idcard_tails_viewUrl = res.viewUrl, that.form.idcard_tails_viewUrl = res.viewUrl);
                n == 0 ? that.form.contactsFrontIdCardPath = res.storeUrl : that.form.contactsBackIdCardPath = res.storeUrl;

                setTimeout(() => {
                    that.percentage = 0;
                    that.currentRate = 0;
                    that.progress = false;
                }, 700)
            }).catch((err) => {
                that.progress = false;

                console.log(err);
            });
        }).catch((err) => {

            console.log(err);
        });


    },

    // 按钮定位
    getScroll() {
        if (this.flag) {
            setTimeout(() => {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                let scrollBottom = document.documentElement.scrollHeight - document.documentElement.scrollTop - document.documentElement.clientHeight;
                if (document.documentElement.scrollHeight > document.documentElement.clientHeight) {
                    this.btnFix = true;
                } else {
                    this.btnFix = false;
                }
                if (scrollBottom < 100) {
                    this.btnFix = false;
                }
                this.flag = true
            }, 500)
        }
        this.flag = false

    },

    // pc h5切换
    resize() {
        if (document.body.clientWidth > 768) {
            this.deviceType = 'PC';
        } else {
            this.deviceType = 'MOBILE';
        }
    },

    // h5校验
    h5Valid() {
        const {
            legal,
            idCard,
            bankName,
            bankNo,
            bankSubbranch,
            contactsName,
            contactsPhone,
            contactsVerifyCode,
            contactsIdCard,
            idcard_front_viewUrl,
            idcard_tails_viewUrl,
            businessUrl,
        } = this.form


        if (isEmpty(businessUrl)) {
            this.$msg('请上传企业营业执照')
            return false
        }

        if (isEmpty(legal)) {
            this.$msg('请输入法定代表人姓名')
            return false
        }
        if (isEmpty(idCard)) {
            this.$msg('请输入法定代表人身份证号码')
            return false
        }
        if (isEmpty(bankName)) {
            this.$msg('请输入企业开户银行')
            return false
        }
        if (isEmpty(bankNo)) {
            this.$msg('请输入企业开户账号')
            return false
        }
        if (isEmpty(bankSubbranch)) {
            this.$msg('请输入开户支行名称')
            return false
        }
        if (isEmpty(contactsName)) {
            this.$msg('请输入联系人姓名')
            return false
        }
        if (isEmpty(contactsPhone)) {
            this.$msg('请输入联系人手机号')
            return false
        }
        if (isEmpty(contactsVerifyCode)) {
            this.$msg('请输入验证码')
            return false
        }
        if (isEmpty(contactsIdCard)) {
            this.$msg('请输入联系人身份证号码')
            return false
        }
        if (isEmpty(idcard_front_viewUrl)) {
            this.$msg('请上传身份证正面')
            return false
        }
        if (isEmpty(idcard_tails_viewUrl)) {
            this.$msg('请上传身份证反面')
            return false
        }
        return true
    },

    // 提交
    submitForm(formName, formType) {
        let that = this;
        this.$refs[formName].validate(async (valid) => {
                if (formType === 1) {
                    sessionStorage.setItem("enterPriseForm", JSON.stringify(this.form));
                    that.$refs.applyForm.clearValidate()
                    that.$msg('保存成功', "success");
                    return false
                } else {
                    if (that.h5Valid()) {
                        if (valid) {
                            that.isLoading = true
                            that.httpRes()
                        } else {
                            that.isLoading = false
                            return false
                        }
                    } else {
                        that.isLoading = false
                    }

                }

            }
        )
    },

    // 提交请求
    httpRes() {
        entRemittanceSupply(this.form).then(res => {
            let that= this
            this.isLoading = false
            if (res) {
                this.$msg('提交成功', "success");
                if (that.deviceType === 'MOBILE') {
                    window.location.href = process.env.VUE_APP_MOBILE_SIGN
                } else {
                    window.location.href = process.env.VUE_APP_SIGN + '/logged/index'
                }
            }
        }).catch(err => {
            this.isLoading = false
        })
    },

    // 返回
    goBack() {
        if (this.deviceType === 'MOBILE') {
            window.location.href = process.env.VUE_APP_MOBILE_SIGN
        } else {
            window.location.href = process.env.VUE_APP_SIGN + '/logged/index'
        }
    },

    // 输入框绑定
    changeValue(e){
        this.$forceUpdate()
    },
}

export default Methods